var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStreams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 110,
    viewBox: "0 0 139 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEF5FF",
    fillRule: "nonzero",
    d: "M88.175,47.9016784 C85.5683333,34.8204217 73.9533333,25 60,25 C48.9216667,25 39.3,31.2183365 34.5083333,40.3183412 C22.97,41.5316752 14,51.2004301 14,62.9166861 C14,75.4671093 20.3420336,83.5052932 37,85.6666978 C53.6579664,87.8281024 72.1764706,87.0148467 84.3529412,85.6666978 C96.5294118,84.318549 106,77.1733601 106,66.7083548 C106,56.6983496 98.1416667,48.5841788 88.175,47.9016784 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7DEE8",
    d: "M90.8492402,32 C101.259388,32 109.69848,40.4342174 109.69848,50.8383518 C109.69848,55.1107889 108.275381,59.0510354 105.877083,62.2114494 L123.826708,80.1615556 C125.391097,81.7259444 125.391097,84.2623197 123.826708,85.8267084 C122.26232,87.3910972 119.725944,87.3910972 118.161556,85.8267084 L118.161556,85.8267084 L99.7712147,67.4368996 C97.1152433,68.8658738 94.0769862,69.6767036 90.8492402,69.6767036 C80.4390923,69.6767036 72,61.2424862 72,50.8383518 C72,40.4342174 80.4390923,32 90.8492402,32 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStreams);
export default __webpack_public_path__ + "static/media/empty-streams.a08f5d93.svg";
export { ForwardRef as ReactComponent };